export class AprobacionComercial {
  static get PROPIEDADES_EXPORTAR() {
    return [
      { value: "IdSec", label: "Id" },
      { value: "NombreComercial", label: "Emisor" },
      { value: "RNCEmisor", label: "RNC Emisor" },
      { value: "TipoeCFDesc", label: "Tipo de Comprobante" },
      { value: "eNCF", label: "e-NCF" },
      { value: "FechaEmision", label: "Fecha de Emisión" },
      { value: "MontoTotal", label: "Monto Total" },
      { value: "EstadoDesc", label: "Estado" },
      { value: "EstatusDesc", label: "Estatus" },
      { value: "CrearUsuario", label: "Usuario Creación" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "ActualizarUsuario", label: "Usuario Actualización" },
      { value: "FechaActualizacion", label: "Fecha Actualización" }
    ]
  }
}